import { useCreateProductStore } from "../useCreateProductStore";

export const useRiskPolicy = () =>
  useCreateProductStore((state) => ({
    policy: state.riskPolicy,
    storeRiskPolicy: state.storeRiskPolicy,
    setDisabled: state.setDisabled,
  }));
